import { IIconProps } from '~/types';
const ZarFlag = (props: IIconProps) => (
  <svg
    width={28}
    height={20}
    viewBox="0 0 28 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={28} height={20} rx={2} fill="#06A86E" />
    <mask
      id="a"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={28}
      height={20}
    >
      <rect width={28} height={20} rx={2} fill="#fff" />
    </mask>
    <g mask="url(#a)" fillRule="evenodd" clipRule="evenodd">
      <path d="M0 2.667 9.333 10 0 17.333z" fill="#FFBF2E" />
      <path d="m-1.334 3 9 7-9 7z" fill="#262626" />
      <path d="M12 8 2.665 0h25.333v8z" fill="#fff" />
      <path d="M12.334 6.667 4.334 0h23.667v6.667z" fill="#F44E46" />
      <path d="M2.666 20h25.333v-8H12z" fill="#fff" />
      <path d="M4.334 20h23.667v-6.666H12.334z" fill="#072CB4" />
    </g>
  </svg>
);
export default ZarFlag;
